import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  Page404,
  LoginPage,
  UserListPage,
  UserCreatePage,
  UserEditPage,
  FolderListPage,
  GeneralAppPage,
  ActivityPage,
  IndicatorsTablePage,
  ChartsPage,
  ProgramAndVolets,
  CarbonPage,
  HistoryPage,
} from './elements';
import IndicatorsPage from 'src/pages/dashboard/folders/IndicatorsPage';
import CarbonStats from 'src/pages/dashboard/carbonStats/CarbonStats';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <GeneralAppPage /> },
        { path: 'programandvolets', element: <ProgramAndVolets /> },
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/list" replace />, index: true },
            { path: ':id/edit', element: <UserEditPage /> },
            { path: 'new', element: <UserCreatePage /> },
            { path: 'list', element: <UserListPage /> },
          ],
        },
        {
          path: 'folder',
          children: [
            { element: <Navigate to="/dashboard/folder/list" replace />, index: true },
            { path: 'list', element: <FolderListPage /> },
            { path: ':id', element: <FolderListPage /> },
            { path: 'indicators/:id', element: <IndicatorsPage /> },
          ],
        },
        {
          path: 'activity',
          children: [
            { element: <Navigate to="/dashboard/activity/list" replace />, index: true },
            { path: 'list', element: <ActivityPage /> },
          ],
        },
        {
          path: 'history',
          children: [
            { element: <Navigate to="/dashboard/history/list" replace />, index: true },
            { path: 'list', element: <HistoryPage /> },
          ],
        },
        {
          path: 'indicators',
          children: [
            { element: <Navigate to="/dashboard/indicators/list" replace />, index: true },
            { path: 'list', element: <IndicatorsTablePage /> },
          ],
        },
        {
          path: 'carbon',
          children: [
            { element: <Navigate to="/dashboard/carbon/list" replace />, index: true },
            { path: 'list', element: <CarbonPage /> },
          ],
        },
        // {
        //   path: 'carbonStats',
        //   children: [
        //     { element: <Navigate to="/dashboard/carbonStats/list" replace />, index: true },
        //     { path: 'list', element: <CarbonStats /> },
        //   ],
        // },
        {
          path: 'charts',
          children: [
            { element: <Navigate to="/dashboard/charts/list" replace />, index: true },
            { path: 'list', element: <ChartsPage /> },
          ],
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
